import { SxProps, Theme } from '@mui/system';
import { bloxValues } from 'themes/constants';

export const miniMenuSx: SxProps<Theme> = {
  '& .MuiMenuItem-root': {
    fontSize: bloxValues.regularFontSizeRem,
  },
};

export const getMiniMenuIconSx = (theme: Theme): SxProps<Theme> => {
  return {
    fontSize: bloxValues.iconSizeRegular,
    color: theme.palette.text.secondary,
    mr: 1,
  };
};
